import { Col, Divider, Modal, notification, Row } from 'antd';
import classNames from 'classnames/bind';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import historyBookingAPI from '~/api/HistoryBooking';
import { IMAGES } from '~/assets/assetsPath';
import { getNumberWithCommas } from '~/utils';
import CancelModal from '../FormCancel';
import DoubleModal from '../FormDouble';
import QRCodeModal from '../QRCodeModal';
import styles from './DetailInfoServiceSection.module.scss';

const cx = classNames.bind(styles);

const Item = styled.div`
    .ant-divider-horizontal {
        margin: 14px 0px;
    }
`;

const DetailInfoServiceSection = ({ item, handleGetBookingInfo }) => {
    const navigate = useNavigate();
    const [isShowQRCodeModal, setIsShowQRCodeModal] = useState(false);
    const [isShowDoubleBookingModal, setIsShowDoubleBookingModal] = useState(false);
    const [isShowCancelBookingModal, setIsShowCancelBookingModal] = useState(false);

    const handleShowQRCodeModal = () => {
        setIsShowQRCodeModal(true);
    };

    const handelShowDoubleBookingModal = () => {
        setIsShowDoubleBookingModal(true);
    };
    const onAgreeDoubleBooking = () => {
        setIsShowDoubleBookingModal(false);
        navigate(`/dat-lich-lai/${item.id}`);
    };
    const onRejectDoubleBooking = () => {
        setIsShowDoubleBookingModal(false);
    };

    const handelShowCancelBookingModal = () => {
        setIsShowCancelBookingModal(true);
    };
    const onAgreeCancelBooking = async () => {
        await handleCancelBooking(item.id);
        await setIsShowCancelBookingModal(false);
    };
    const onRejectCancelBooking = () => {
        setIsShowCancelBookingModal(false);
    };
    const handleCancelBooking = async (id) => {
        try {
            const res = await historyBookingAPI.cancelBookingAPI(id);
            if (res.code === 200) {
                notification.open({
                    message: 'Cancellation successful',
                    duration: 2,
                    placement: 'top',
                });
                await handleGetBookingInfo();
            }
        } catch (err) {
            console.log(err);
            if (err.message) {
                notification.open({
                    message: err.message,
                    duration: 2,
                    placement: 'top',
                });
            }
        }
    };

    return (
        <Item>
            <div className={cx('container')}>
                <Row align="middle" className={cx('name_section')}>
                    Service
                </Row>
                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                {item?.booking_details?.length
                    ? item.booking_details?.map((service, index) => {
                        return (
                            <>
                                <Row
                                    className={cx('service')}
                                    key={index}
                                    onClick={() => navigate(`/dich-vu-chi-tiet/${service.service.id}`)}
                                >
                                    <Col xs={6} xl={5}>
                                        <Row className={cx('image')}>
                                            <img src={service.image || IMAGES.ImagePlaceholder} alt="" />
                                        </Row>
                                    </Col>
                                    <Col xs={18} xl={19} className={cx('content')}>
                                        <div>
                                            <Row className={cx('name')}>{service.title}</Row>
                                            <Row className={cx('type')}>
                                                Service:  <span>{service.category_name}</span>
                                            </Row>
                                            <Row className={cx('time')}>
                                                Time:  <span>{service.execution_time} minutes</span>
                                            </Row>
                                            <Row className={cx('type')}>x{service.count}</Row>
                                        </div>
                                    </Col>
                                    <Col xs={24}>
                                        <Row className={cx('right_content')}>
                                            {service?.combo_service_id ? (
                                                <div className={cx('tag_combo_service')}>
                                                    {service?.combo_service?.title}
                                                </div>
                                            ) : (
                                                <>
                                                    {parseInt(service.discount) ? (
                                                        <div className={cx('old_price')}>
                                                            <del>
                                                                {getNumberWithCommas(service.price)}&nbsp;
                                                                {service?.service?.unit_id
                                                                    ? `d/${service?.service?.unit?.value}`
                                                                    : 'd'}
                                                            </del>
                                                        </div>
                                                    ) : null}
                                                    <div className={cx('new_price')}>
                                                        {getNumberWithCommas(service.price - service.discount)}&nbsp;
                                                        {service?.service?.unit_id
                                                            ? `d/${service?.service?.unit?.value}`
                                                            : 'd'}
                                                    </div>
                                                </>
                                            )}
                                        </Row>
                                    </Col>
                                </Row>
                                <Divider style={{ borderTop: '2px solid rgba(0,0,0,.06)' }} />
                            </>
                        );
                    })
                    : null}{' '}
                {Number(item?.discount) ? (
                    <Row className={cx('total_price')}>
                        <Col xs={12}>
                            <Row className={cx('title')}>Reduced:</Row>
                        </Col>
                        <Col xs={12}>
                            <Row justify="end" className={cx('price')}>
                                - {getNumberWithCommas(item.discount)} d
                            </Row>
                        </Col>
                    </Row>
                ) : null}
                <Row className={cx('total_price')}>
                    <Col xs={12}>
                        <Row className={cx('title')}>Total amount:</Row>
                    </Col>
                    <Col xs={12}>
                        <Row justify="end" className={cx('price')}>
                            {getNumberWithCommas(item.total_price)} d
                        </Row>
                    </Col>
                </Row>
                <Row className={cx('footer')} align="middle">
                    <Col xs={9}>
                        <Row className={cx('payment_type')}>
                            {item.booking_type === 'CASH' && <span>Cash payment</span>}
                            {item.booking_type === 'CARD' && <span>Pay by card</span>}
                            {item.booking_type === 'WALLET' && <span>Pay with service limit wallet</span>}
                            {item.booking_type === 'TRANSFER' && <span>Pay by transfer</span>}
                        </Row>
                    </Col>
                    <Col xs={15}>
                        <Row justify="end">
                            {item.activity === 'WAITING' && (
                                <div className={cx('btn', 'detail')} onClick={handelShowCancelBookingModal}>
                                    Cancel appointment
                                </div>
                            )}
                            {(item.activity === 'COMPLETED' || item.activity === 'CANCELED') && (
                                <div className={cx('btn', 'detail')} onClick={handelShowDoubleBookingModal}>
                                    Reset
                                </div>
                            )}
                            <div className={cx('btn', 'cancel')} onClick={handleShowQRCodeModal}>
                                QR Code
                            </div>
                        </Row>
                    </Col>
                </Row>
            </div>

            {isShowQRCodeModal && (
                <Modal
                    centered
                    visible={isShowQRCodeModal}
                    closable={false}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <QRCodeModal setIsShowQRCodeModal={setIsShowQRCodeModal} item={item} />
                </Modal>
            )}
            {isShowDoubleBookingModal && (
                <Modal
                    centered
                    visible={isShowDoubleBookingModal}
                    onCancel={onRejectDoubleBooking}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <DoubleModal
                            onRejectDouble={onRejectDoubleBooking}
                            onAgreeDouble={onAgreeDoubleBooking}
                            text="Do you want to reschedule this booking?"
                        />
                    </div>
                </Modal>
            )}
            {isShowCancelBookingModal && (
                <Modal
                    centered
                    visible={isShowCancelBookingModal}
                    onCancel={onRejectCancelBooking}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <CancelModal
                            onRejectCancel={onRejectCancelBooking}
                            onAgreeCancel={onAgreeCancelBooking}
                            text="Do you want to cancel this booking?"
                        />
                    </div>
                </Modal>
            )}
        </Item>
    );
};

export default DetailInfoServiceSection;
